<template>
  <v-container grid-list-xl>
    <v-layout justify-center row wrap>
      <v-flex xs12>
        <w-main-title
          class="pb-0"
          title="Solicitudes de Presupuesto"
          :breadcrumbs="breadcrumbs"
        ></w-main-title>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12 sm4>
            <v-select
              label="Tipo"
              :items="types"
              item-text="text"
              item-value="value"
              v-model="type"
              clearable
              prepend-icon="fas fa-adjust"
            ></v-select>
            <v-select
              label="Estado"
              :items="statuses"
              item-text="text"
              item-value="value"
              v-model="status"
              clearable
              prepend-icon="fas fa-toggle-on"
            ></v-select>
            <date-picker label="Fecha Desde" ref="from"></date-picker>
            <date-picker label="Fecha Hasta" ref="to"></date-picker>
            <v-btn
              block
              outlined
              color="primary"
              small
              @click="applyFilters"
              :loading="consulting"
              >Aplicar Filtro</v-btn
            >
          </v-flex>
          <v-flex xs12 sm8>
            <v-layout row wrap v-if="loadingQuotationFromApi">
              <v-flex xs12 class="text-center">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-else>
              <v-flex xs12 v-if="filteredQuotations.length === 0">
                <h3 class="font-weight-light text-center mt-4">
                  No posee solicitudes de presupuesto
                </h3>
              </v-flex>
              <template v-else>
                <v-flex
                  xs12
                  sm6
                  v-for="item in filteredQuotations"
                  :key="item.id"
                >
                  <quotation-list-item
                    text="Solicitado el"
                    :item="item"
                    :user="item.user"
                    :services="servicesItems"
                    :showStatusIcon="true"
                    @clicked="openModal(item)"
                  ></quotation-list-item>
                </v-flex>
              </template>
              <v-flex xs12>
                <item-counter
                  :length="filteredQuotations.length"
                  :total="totalItems"
                ></item-counter>
                <next-page-btn
                  :loading="consulting"
                  v-if="nextPageUrl"
                  :nextFn="loadNextPage"
                ></next-page-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-dialog v-model="modalQuotationData" max-width="400px" >
        <v-card>
          <v-card-text>
            <simple-quotation-modal-info
              ref="quotationModal"
              :services="servicesItems"
              :disabled="quotationSelected.quoted"
              :quotation="quotationSelected"
              :data="quotationSelected"
            ></simple-quotation-modal-info>
            <v-btn
              block
              outlined
              color="primary"
              @click="quotationEntry"
              :loading="consultingTemplate"
              :disabled="quotationSelected.quoted"
            >
              {{
                quotationSelected.quoted
                  ? 'Ya Existe Presupuesto Asociado'
                  : 'Ingresar Presupuesto'
              }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="modalQuotationTemplate"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dense color="primary" dark depressed fixed>
            <v-toolbar-title>Ingreso de Presupuesto</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn text @click="closeQuotationModal">
                Cerrar
              </v-btn>
              <v-btn
                text
                class="accent"
                @click="saveQuotationTemplate"
                :loading="creatingQuotation"
                >Guardar</v-btn
              >
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <quotation-template
              ref="quotationTemplate"
              :template="quotationTemplate"
              :servicesItems="servicesItems"
              :isFromTemplate="isFromTemplate"
            ></quotation-template>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
import { ApiUtils } from '@/utils/ApiUtils'
import { queryFilterBuilder } from '@/utils/Shared'

export default {
  components: {
    WMainTitle: () => import('@/components/common/WMainTitle'),
    QuotationListItem: () =>
      import('@/components/providers/quotations/QuotationListItem'),
    OfferListItem: () =>
      import('@/components/providers/quotations/OfferListItem'),
    QuotationTemplate: () =>
      import('@/components/providers/quotations/QuotationTemplate'),
    SimpleQuotationModalInfo: () =>
      import('@/components/providers/quotations/SimpleQuotationModalInfo'),
    QuotationFilter: () =>
      import('@/components/providers/quotations/QuotationFilter'),
    DatePicker: () => import('@/components/common/DatePicker'),
    NextPageBtn: () => import('@/components/common/NextPageBtn'),
    ItemCounter: () => import('@/components/common/ItemCounter')
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Solicitudes de Presupuesto',
          disabled: true,
          href: ''
        }
      ],
      modalQuotationData: false,
      modalQuotationTemplate: false,
      quotations: [],
      currentPage: 0,
      totalPages: 0,
      totalItems: 0,
      nextPageUrl: null,
      services: [],
      consulting: false,
      consultingTemplate: false,
      quotationSelected: {},
      quotationTemplate: null,
      servicesItems: [],
      loadingQuotationFromApi: false,
      isFromTemplate: false,
      itemURL: 'quotation_requests',
      //filters
      type: '',
      status: '',
      types: [
        { text: 'Presupuesto', value: 'service' },
        { text: 'Promoción', value: 'special_sale' }
      ],
      statuses: [
        { text: 'Solicitado', value: 'pending' },
        { text: 'Completado', value: 'created' }
      ]
    }
  },
  async created() {
    this.servicesItems = await this.$store.dispatch(
      'quotations/loadProviderServices',
      { providerId: this.providerData[0].id }
    )
  },
  async mounted() {
    if (this.providerData.length > 0) {
      const url = `quotations/provider/${this.providerData[0].id}/requests`
      await this.initilize(url)
    }
  },
  watch: {
    modalQuotationData: function(val1, val2) {
      if (val1 === true && val2 === false && !!this.$refs.quotationModal) {
        this.$refs.quotationModal.segment = 'paciente'
      }
    }
  },
  computed: {
    creatingQuotation() {
      return this.$store.getters['quotations/creatingQuotation']
    },
    providerData() {
      return this.$store.getters.currentUser.service_providers
    },
    filteredQuotations() {
      const all = []
      let dateFilter = this.quotations
      dateFilter.forEach(quote => {
        quote.isServiceItem = quote.service_items.length > 0
        quote.isSpecialSale = !!quote.special_sale
        all.push(quote)
      })
      return all
    }
  },
  methods: {
    async initilize(url) {
      try {
        this.loadingQuotationFromApi = true
        const initialized = await this.$store.dispatch(
          'quotations/initialLoad',
          {
            url,
            itemURL: this.itemURL
          }
        )
        if (initialized.ok) {
          const pageData = initialized.pageData
          this.loadPageData(pageData)
          this.services = initialized.services
        }
      } catch (err) {

      } finally {
        this.loadingQuotationFromApi = false
      }
    },
    async applyFilters() {
      const filters = {
        type: this.type,
        status: this.status,
        start_date: this.$refs.from.date,
        end_date: this.$refs.to.date,
      }
      const query = queryFilterBuilder(filters)
      this.consulting = true
      let url = ''
      if (query.ok)
        url = `quotations/provider/${this.providerData[0].id}/requests?${query.query}`
      else
        url = `quotations/provider/${this.providerData[0].id}/requests`
      await this.initilize(url)
      this.consulting = false
    },
    async loadNextPage() {
      if (this.nextPageUrl === null) return
      this.consulting = true
      try {
        const pageData = await this.$store.dispatch('quotations/loadNextPage', {
          nextPageUrl: this.nextPageUrl,
          itemURL: this.itemURL,
          actual: this.quotations
        })
        this.loadPageData(pageData)
      } catch (error) {

      } finally {
        setTimeout(() => {
          this.consulting = false
        }, 1000)
      }
    },
    loadPageData(payload) {
      this.currentPage = payload.currentPage || 0
      this.totalItems = payload.totalItems || 0
      this.nextPageUrl = payload.nextPageUrl || null
      this.quotations = payload.quotations || []
    },
    openModal(item) {
      this.quotationSelected = item
      this.modalQuotationData = true
    },
    openModalOffer(item) {
      this.quotationSelected = item
      this.modalQuotationData = true
    },
    async quotationEntry() {
      this.consultingTemplate = true
      this.isFromTemplate = true
      const request = await ApiUtils.makeGet(
        `quotations/requests/${this.quotationSelected.id}/template`
      )
      const response = await request.json()
      this.quotationTemplate = response.result.template
      this.consultingTemplate = false
      this.modalQuotationData = false
      this.openQuotationModal()
    },
    async saveQuotationTemplate() {
      const r = this.$refs.quotationTemplate.saveQuotation()
      const quotationSend = await this.$store.dispatch(
        'quotations/saveNewQuotation',
        {
          providerId: this.$store.getters.currentUser.service_providers[0].id,
          data: r,
          isFromTemplate: this.isFromTemplate,
          quotationSelected: this.isFromTemplate
            ? this.quotationSelected.id
            : null,
          isSpecialSale: this.quotationSelected.isSpecialSale,
          successMessage: 'Presupuesto Creado'
        }
      )
      if (quotationSend.ok) {
        const id = this.quotationSelected.id
        const sel = this.quotations.find(el => el.id === id)
        sel.quoted = true
        this.closeQuotationModal()
      }
    },
    async createNewQuotation() {
      this.servicesItems = await this.$store.dispatch(
        'quotations/loadProviderServices',
        { providerId: this.providerData[0].id }
      )
      this.isFromTemplate = false
      this.quotationTemplate = {
        items: [],
        client: []
      }
      this.openQuotationModal()
    },
    openQuotationModal() {
      this.modalQuotationTemplate = true
      setTimeout(() => {
        this.$refs.quotationTemplate.initModal()
      }, 200)
    },
    closeQuotationModal() {
      this.$refs.quotationTemplate.cleanItems()
      this.modalQuotationTemplate = false
    }
  }
}
</script>
